// Lo que el navegador del visitante puede no traer y core-js 2 no rellena.
//
// Array.prototype.at: Safari lo trae recién desde iOS 15.4. Los chatbots lo
// usan en `scrollToMsg` (`msgRef.at(-1)`), y en un iPhone más viejo eso lanza
// un TypeError: no hay scroll y, en PlanificationDemo, se corta en esa misma
// línea el guion que reproduce la demo. Uno solo acá cubre a todos los que lo
// usan y a los que lo usen mañana.
//
// ponytail: relleno a mano porque el proyecto está en core-js 2, que no lo
// trae; al subir a core-js 3 (useBuiltIns) este archivo sobra.
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, "at", {
    value: function at(index) {
      let n = Math.trunc(index) || 0;
      if (n < 0) n += this.length;
      return n < 0 || n >= this.length ? undefined : this[n];
    },
    writable: true,
    configurable: true,
  });
}
